/* Pertegaz search panel.
   Open / close / clear / focus-trap come from Dawn's <details-modal> and
   <search-form>/<predictive-search>. This file adds the custom behaviour on top:
   - the default⇄results switch (.pz-search--typing) so our "Sugerencias" + products
     carousel show before typing and the live results show while typing;
   - the products carousel arrows (same caret/step as the collection scrollers).
   Scroll-lock + panel placement are handled in CSS (desktop: dropdown under the header;
   mobile: a full-screen overlay). Guarded so it binds once. */
(function () {
  if (window.__pzSearchInit) return;
  window.__pzSearchInit = true;

  function initRoot(root) {
    if (root.__pzInit) return;
    root.__pzInit = true;

    var input = root.querySelector('.pz-search__input');
    var details = root.querySelector('details');
    var inner = root.querySelector('.pz-search__inner');
    var header = root.closest('.header-wrapper') || root.closest('.header') || document.querySelector('.header-wrapper');

    // Cap the panel to the space below the header: short content (suggestions + carousel) stays
    // its natural height so the panel grows with it; tall content (results grid) scrolls within
    // the cap. Uses window.innerHeight (stable) — NOT visualViewport, which shrinks with the
    // on-screen keyboard and would squash the panel.
    function sizeInner() {
      if (!inner) return;
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      inner.style.maxHeight = Math.max(240, window.innerHeight - top) + 'px';
    }
    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    // ---- default ⇄ results toggle -------------------------------------------
    function sync() {
      var has = input && input.value.trim().length > 0;
      root.classList.toggle('pz-search--typing', !!has);
    }
    if (input) input.addEventListener('input', sync);

    // "Borrar" (reset) → clears the field, so drop back to the default state
    var clearBtn = root.querySelector('.pz-search__clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        setTimeout(function () { sync(); if (input) input.focus(); }, 0);
      });
    }

    // ---- carousel ------------------------------------------------------------
    // ---- transform-based slider (no native scroll → no iOS momentum / phantom trailing space) --
    var track = root.querySelector('[data-pz-search-track]');
    var viewport = root.querySelector('[data-pz-search-viewport]');
    var nav = root.querySelector('[data-pz-search-nav]');
    var prev = nav && nav.querySelector('.slider-button--prev');
    var next = nav && nav.querySelector('.slider-button--next');
    var offset = 0, maxOffset = 0, gap = 20, slideW = 0;

    function slides() { return track ? track.querySelectorAll('.pz-search__slide') : []; }
    function apply() {
      if (track) track.style.transform = 'translateX(' + (-offset) + 'px)';
      if (prev) prev.classList.toggle('is-dim', offset <= 1);
      if (next) next.classList.toggle('is-dim', offset >= maxOffset - 1);
    }
    function clamp() { offset = Math.max(0, Math.min(offset, maxOffset)); }
    function layout() {
      if (!track || !viewport) return;
      var vw = viewport.clientWidth;
      if (vw === 0) return;
      gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var list = slides();
      // exactly 2 cards per view on mobile, 5 on desktop
      slideW = isMobile() ? Math.floor((vw - gap) / 2) : Math.round((vw - 4 * gap) / 5);
      for (var i = 0; i < list.length; i++) { list[i].style.flex = '0 0 ' + slideW + 'px'; list[i].style.width = slideW + 'px'; }
      var total = list.length * slideW + Math.max(0, list.length - 1) * gap;
      maxOffset = Math.max(0, total - vw);
      clamp();
      apply();
    }
    function stepBy(dir) {
      offset += dir * (slideW + gap) * 2; // ~2 cards per click
      clamp();
      apply();
    }
    if (track) {
      if (prev) prev.addEventListener('click', function () { stepBy(-1); });
      if (next) next.addEventListener('click', function () { stepBy(1); });
    }
    var updateNav = layout; // opening / resizing recomputes the whole slider
    window.addEventListener('resize', function () { sizeInner(); layout(); });

    // ---- focus + measure when the panel opens --------------------------------
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        [0, 60, 220, 460].forEach(function (t) {
          setTimeout(function () {
            sizeInner();
            // don't auto-focus on mobile — the keyboard would immediately cover the carousel
            if (t === 60 && input && !isMobile()) input.focus();
            sync();
            updateNav();
            // the cards were hidden at load (0 width) so their image-slider progress thumb sized
            // to zero — nudge pz-collection.js to recompute it now that the panel is visible
            if (t === 220 || t === 460) { try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
          }, t);
        });
      });
    }

    sync();
  }

  function initAll() {
    var roots = document.querySelectorAll('.pz-search');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
